import { useTranslation } from 'react-i18next';
import _get from 'lodash/get';
import { AiDocumentationFieldEnum, Documentation } from 'graphql-common';
import CategoryCell from '@lib/components/Table/commonComponents/CategoryCell/CategoryCell';
import { AiCredits } from 'components/AiAssistant/AiCreditsIndicator';
import { AiFieldUiState } from 'routes/Documentation/utils/getAiFieldDetectionState';
import AiFieldAssist from 'routes/Documentation/components/AiDetection/AiFieldAssist';
import useDocumentFieldDetection from 'routes/Documentation/DocumentView/utils/useDocumentFieldDetection';

type Props = {
  item: Documentation;
  isAiDetectionEnabled?: boolean;
  credits?: AiCredits | null;
};

export default function DocumentCategoryCell({
  item,
  isAiDetectionEnabled,
  credits,
}: Props) {
  const { t } = useTranslation();
  const { category } = useDocumentFieldDetection({
    doc: item,
    documentationVersionId: item.currentVersion?.id,
    isAiEnabled: !!isAiDetectionEnabled,
  });

  if (!isAiDetectionEnabled || category.uiState === AiFieldUiState.None) {
    return (
      <CategoryCell
        label={item.category?.name}
        color={_get(item.category, 'color')}
      />
    );
  }

  return (
    <AiFieldAssist
      field={AiDocumentationFieldEnum.Category}
      resolveSource={category.resolveSource}
      onApplyCategoryId={category.onApplyCategoryId}
      detectionUiState={category.uiState}
      // Mirrors getCategoryFields.tsx's existing (pre-existing, out of scope)
      // reuse of the CODE detecting copy for CATEGORY.
      detectingLabel={t('ai-detecting-code')}
      onDismiss={category.onDismiss}
      creditsRemaining={credits}
      labels={{
        idleLabel: t('ai-suggest-with-ai'),
        idleCta: t('ai-suggest-category-cta'),
        regenerateCta: t('ai-regenerate'),
      }}
    />
  );
}
